<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input class="input is-uppercase"
                type="text"
                placeholder="Search..."
                v-model="innerValue.search"
                @keyup="onFilterClick()">
            </div>
            <div class="help">
              Search by
              <ul>
                <li>Quote No.</li>
                <li>Rego No.</li>
                <li>Customer Name/Phone</li>
                <li>Claim No.</li>
                <li>Car Make/Model.</li>
              </ul>

            </div>
          </div>
          <!-- <div class="field">
            <div class="control">
              <input class="input"
                v-model="innerValue.claimNo"
                type="text"
                placeholder="Claim No."
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input"
                v-model="innerValue.vehicleNo"
                type="text"
                placeholder="Vehicle No."
                @keyup.enter="onFilterClick()">
            </div>
          </div> -->
          <div class="field"
            @focusout="onFilterClick()">
            <v-date-picker v-model="selectedFromDate"
              :is-dark="$theme.isDark"
              :masks="formats"
              :attributes="attrs"
              :model-config="modelConfig"
              :locale="$userInfo.locale"
              :timezone="$filters.getIanaTimezone()">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Date From..."
                      :value="inputValue"
                      v-on="inputEvents">
                    <span class="icon is-small is-left">
                      <i class="mdi mdi-calendar mdi-18px" />
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
          <div class="field"
            @focusout="onFilterClick()">
            <v-date-picker v-model="selectedToDate"
              :is-dark="$theme.isDark"
              :masks="formats"
              :attributes="attrs"
              :model-config="modelConfig"
              :locale="$userInfo.locale"
              :timezone="$filters.getIanaTimezone()">
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Date To..."
                      :value="inputValue"
                      v-on="inputEvents">
                    <span class="icon is-small is-left">
                      <i class="mdi mdi-calendar mdi-18px" />
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="innerValue.taskStatus"
                  @change="onFilterClick()">
                  <option selected="selected"
                    value="">-- Status --</option>
                  <option value="new">New</option>
                  <option value="quote">Quote</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="innerValue.taskType"
                  @change="onFilterClick()">
                  <option selected="selected"
                    value="">-- Booking Type --</option>
                  <option value="repx">Repx</option>
                </select>
              </div>
            </div>
          </div>
          <div class="buttons has-addons">
            <span class="button"
              :class="{ 'is-primary is-selected' : innerValue.active === 0}"
              @click="changeActive(0)">
              <span class="icon is-small">
                <i class="mdi mdi-adjust" />
              </span>
              <span>Both</span>
            </span>
            <span class="button"
              :class="{ 'is-success is-selected' : innerValue.active === 1}"
              @click="changeActive(1)">
              <span class="icon is-small">
                <i class="mdi mdi-check" />
              </span>
              <span>Active</span>
            </span>
            <span class="button"
              :class="{ 'is-danger is-selected' : innerValue.active === 2}"
              @click="changeActive(2)">
              <span class="icon is-small">
                <i class="mdi mdi-close" />
              </span>
              <span>In-Active</span>
            </span>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import OrmBatchingMixin from '@/views/ormbatching/OrmBatchingMixin'

export default {
  name: 'BookingListSideMenu',
  components: {
    AppSideMenu
  },
  mixins: [OrmBatchingMixin],
  props: {
    value: null
  },
  data() {
    return {
      innerValue: this.value,
      // selectedBatchDate: null,
      selectedFromDate: null,
      selectedToDate: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ],
      modelConfig: {
        timeAdjust: '00:00:00'
      }
    }
  },
  computed: {
    // ormBatchStatusType() {
    //   return OrmBatchStatusType
    // }
  },
  watch: {
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    value: {
      handler: function (newVal, oldVal) {
        this.innerValue = this.value
      },
      deep: true
    },
    // selectedBatchDate(newVal, oldVal) {
    //   if (newVal) {
    //     this.innerValue.batchDate = newVal.toISOString().split('.')[0] + 'Z'
    //   } else {
    //     this.innerValue.batchDate = null
    //   }
    // },
    selectedFromDate(newVal, oldVal) {
      if (newVal) {
        this.innerValue.fromDate = newVal.toISOString()
      } else {
        this.innerValue.fromDate = null
      }
    },
    selectedToDate(newVal, oldVal) {
      if (newVal) {
        this.innerValue.toDate = newVal.toISOString()
      } else {
        this.innerValue.toDate = null
      }
    }
  },
  created() {
    // if (this.value.batchDate) {
    //   this.selectedBatchDate = new Date(this.value.batchDate)
    // }
    if (this.value.fromDate) {
      this.selectedFromDate = new Date(this.value.fromDate)
    }
    if (this.value.toDate) {
      this.selectedToDate = new Date(this.value.toDate)
    }
  },
  mounted() {},
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.innerValue.claimNo = null
      this.innerValue.vehicleNo = null
      this.selectedFromDate = null
      this.selectedToDate = null
      this.$emit('reset')
    },
    changeActive(value) {
      this.innerValue.active = value
      this.onFilterClick()
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/style/mixins/inputs/placeholder' as *;;

input.is-uppercase {
  text-transform: uppercase;
  @include reset-placeholder-text-transform;
}
</style>
